import { render, staticRenderFns } from "./NavOverlayItem.vue?vue&type=template&id=f2b05850"
import script from "./NavOverlayItem.vue?vue&type=script&lang=js"
export * from "./NavOverlayItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports